import { Tooltip } from '@app/components/various/Tooltip';
import { cn } from '@app/utils/cn';
import { getBackgroundBySwatch } from '@app/utils/getBackgroundBySwatch';
import { SwatchData } from '@typings';
import React from 'react';

import { SwatchCheck } from './SwatchCheck';

interface Props {
  isSelected: boolean;
  handleClick: (event: React.SyntheticEvent<EventTarget>) => void;
  swatchData: SwatchData;
}

export const SwatchCheckbox = ({ isSelected, handleClick, swatchData }: Props) => {
  const background = getBackgroundBySwatch(swatchData);

  return (
    <Tooltip placement="top-center" content={swatchData.desc}>
      <span
        className={cn(
          'group relative block h-6 w-6 rounded-small border border-neutral-90 transition-colors focus-within:focus-outline hover:border-neutral-80',
          {
            'border-neutral-20 hover:border-neutral-40': isSelected,
          },
        )}
      >
        <span style={{ background }} className="absolute inset-0.5 rounded-[2px]"></span>

        <SwatchCheck
          aria-hidden={!isSelected}
          className={cn(
            'absolute -right-px -top-px h-[0.875rem] w-[0.875rem] opacity-0 transition-[color,opacity] group-hover:text-neutral-40',
            {
              'opacity-100': isSelected,
            },
          )}
        />
        <input
          className="absolute inset-0 z-elevated h-full w-full cursor-pointer opacity-0"
          onChange={handleClick}
          type="checkbox"
          checked={isSelected}
          aria-label={swatchData.desc}
          aria-checked={isSelected}
        />
      </span>
    </Tooltip>
  );
};
